export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Menu.vue?vue&type=template&id=55051c93"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Menu.vue?vue&type=template&id=55051c93
// module id = 139
// module chunks = 0